import React from "react";
import StaffTendersMobileHeader from "../staff/responsive/StaffTendersMobileHeader";
import CustomDropdown from "../common/CustomDropdown";
import TransferWindowStatusLine from "../common/TransferWindowStatusLine";

const CoachTendersHeader = ({
  isMobile,
  transferWindowLoading,
  transferWindow,
  formatDateRange,
  dropdownRef,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  handleTransferWindowDropdownToggle,
  countries,
  selectedCountry,
  isTransferWindowDropdownOpen,
  handleCountrySelect,
  coachInClub,
  canCreateTenders,
  activeMainTab,
  setActiveMainTab,
  searchTerm,
  handleSearchChange,
  setShowFilterModal,
  hasActiveFilters,
  getActiveFiltersCount,
  clearAllFilters,
  sortBy,
  handleSortChange,
  isYouthCoach,
  canViewPitches,
  navigate,
}) => {
  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (isMobile) {
    return (
      <StaffTendersMobileHeader
        transferWindowLoading={transferWindowLoading}
        transferWindow={transferWindow}
        formatDateRange={formatDateRange}
        dropdownRef={dropdownRef}
        searchInputRef={searchInputRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleTransferWindowDropdownToggle={handleTransferWindowDropdownToggle}
        countries={countries}
        selectedCountry={selectedCountry}
        isTransferWindowDropdownOpen={isTransferWindowDropdownOpen}
        filteredCountries={filteredCountries}
        handleCountrySelect={handleCountrySelect}
        staffInClub={coachInClub}
        canCreateTenders={canCreateTenders}
      />
    );
  }

  return (
    <div className="border-b bg-white">
      <div className=" mx-auto ">
        <div className="flex justify-between items-center py-4 px-12 border-b border-[#E5E6E8]">
          <h1 className="text-xl font-semibold">Requests</h1>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <TransferWindowStatusLine
                country={selectedCountry}
                category="mens_professional"
                variant="precise-dates"
                className="text-[#000000] text-sm font-medium"
              />
            </div>
            <div className="relative" ref={dropdownRef}>
              <button
                className="flex items-center gap-2 px-3 py-1.5 border rounded-lg hover:bg-gray-50"
                onClick={handleTransferWindowDropdownToggle}
              >
                {countries.find((c) => c.name === selectedCountry)?.flag && (
                  <img
                    src={countries.find((c) => c.name === selectedCountry)?.flag}
                    alt={selectedCountry}
                    className="w-5 h-5"
                  />
                )}
                <span>{selectedCountry || "Select country"}</span>
                <svg
                  className={`w-4 h-4 transition-transform duration-200 ${
                    isTransferWindowDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {isTransferWindowDropdownOpen && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[250px] overflow-hidden">
                  <div className="p-3 border-b border-gray-200">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg
                          className="h-4 w-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                      <input
                        ref={searchInputRef}
                        type="text"
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm text-gray-900"
                        placeholder="Search country"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>

                  <div className="overflow-y-auto max-h-48">
                    {filteredCountries.length > 0 ? (
                      filteredCountries
                        .filter((country) => !country.isViewAll)
                        .map((country, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-gray-700"
                            onClick={() => handleCountrySelect(country)}
                          >
                            {country.flag && (
                              <img
                                src={country.flag}
                                alt={country.name}
                                className="w-6 h-6"
                              />
                            )}
                            <span className="text-sm">{country.name}</span>
                          </div>
                        ))
                    ) : (
                      <div className="px-3 py-2 text-gray-500 text-sm">
                        No countries found
                      </div>
                    )}
                  </div>

                  <div
                    className="px-3 py-2 cursor-pointer bg-[#2283FF] text-center text-[#F5F5F5]"
                    onClick={() => handleCountrySelect({ isViewAll: true })}
                  >
                    <span className="text-sm font-medium">View All</span>
                  </div>
                </div>
              )}
            </div>
            {coachInClub && canCreateTenders && (
              <button
                onClick={() => navigate("/club/tenders/create")}
                className="flex items-center gap-2 px-4 py-2 bg-[#2283FF] text-white rounded-lg hover:bg-blue-600"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                Create Request
              </button>
            )}
          </div>
        </div>

        <div className="flex justify-between items-center py-4 px-12">
          <div className="flex gap-8">
            {coachInClub && canViewPitches && (
              <button
                className={`text-[16px] px-3 py-2 rounded-lg ${
                  activeMainTab === "my-tenders"
                    ? " text-[#0B0B0B] bg-[#F3F4F6]"
                    : "text-[#1E1E1ECC]"
                }`}
                onClick={() => setActiveMainTab("my-tenders")}
              >
                My Requests
              </button>
            )}
            <button
              className={`text-[16px] px-3 py-2 rounded-lg ${
                activeMainTab === "all-tenders"
                  ? "text-[#0B0B0B] bg-[#F3F4F6]"
                  : "text-[#1E1E1E]"
              }`}
              onClick={() => setActiveMainTab("all-tenders")}
            >
              All Listed Requests
            </button>
            <button
              className={`text-[16px] px-3 py-2 rounded-lg ${
                activeMainTab === "saved"
                  ? "text-[#0B0B0B] bg-[#F3F4F6]"
                  : "text-[#1E1E1E]"
              }`}
              onClick={() => setActiveMainTab("saved")}
            >
              Saved
            </button>
            {/* Applied — self-applications. Only for coaches WITHOUT a club:
                in-club coaches can't pitch themselves (the Apply CTA never
                renders for them), so the tab does not exist for them. */}
            {!coachInClub && (
              <button
                className={`text-[16px] px-3 py-2 rounded-lg ${
                  activeMainTab === "applied"
                    ? "text-[#0B0B0B] bg-[#F3F4F6]"
                    : "text-[#1E1E1E]"
                }`}
                onClick={() => setActiveMainTab("applied")}
              >
                Applied
              </button>
            )}
          </div>

          {/* The browse toolbar acts on the TENDER query — on the Applied tab
              every one of these controls would be a dead switch, so the
              cluster hides (the Applied surface brings its own status row). */}
          {activeMainTab !== "applied" && (
          <div className="flex items-center gap-4">
            <div className="relative w-64">
              <input
                type="text"
                placeholder="Search by position or club name"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-[#E6E6E6] placeholder:text-[#1E1E1E] rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              <svg
                className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                fill="none"
                stroke="#2C2C2C"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <button
              onClick={() => setShowFilterModal(true)}
              className={`px-4 py-2 border rounded-lg hover:bg-gray-50 ${
                hasActiveFilters()
                  ? "border-blue-500 text-blue-600 bg-blue-50"
                  : ""
              }`}
            >
              Filters{" "}
              {hasActiveFilters() && (
                <span className="ml-1 px-2 py-0.5 text-xs bg-blue-100 rounded-full">
                  {getActiveFiltersCount()}
                </span>
              )}
            </button>
            {hasActiveFilters() && (
              <button
                onClick={clearAllFilters}
                className="px-3 py-2 text-sm text-red-600 border border-red-300 rounded-lg hover:bg-red-50"
              >
                Clear All
              </button>
            )}
            <div className="min-w-[180px]">
              <CustomDropdown
                options={[
                  { value: "pro", label: "Pro" },
                  { value: "youth", label: "Youth" },
                ]}
                value={sortBy}
                onChange={(value) => handleSortChange(value)}
                placeholder="Pro"
                className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-[#2283FF] rounded-lg"
                disabled={isYouthCoach}
              />
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoachTendersHeader;

